import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_17396_28159)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M19.1675 10.2051C19.1675 9.45091 19.105 8.90091 18.9708 8.33008H10.1875V11.7326H15.3425C15.2392 12.5776 14.6783 13.8509 13.4308 14.7067L13.4133 14.8201L16.19 16.9284L16.3817 16.9467C18.15 15.3484 19.1675 12.9951 19.1675 10.2051Z",
					fill: "#4285F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1848 19.1667C12.7098 19.1667 14.8298 18.3517 16.379 16.9458L13.4273 14.7058C12.6373 15.2458 11.5773 15.6225 10.1848 15.6225C9.011 15.6226 7.86663 15.2552 6.91223 14.5719C5.95782 13.8886 5.24128 12.9237 4.86313 11.8125L4.75312 11.8217L1.86563 14.0117L1.82812 14.115C3.36646 17.1092 6.52646 19.1667 10.1848 19.1667Z",
					fill: "#34A853"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.86927 11.8123C4.6643 11.2299 4.55812 10.6173 4.5551 9.99984C4.5551 9.36818 4.6701 8.75734 4.85594 8.18734L4.85094 8.06484L1.9276 5.83984L1.83177 5.88484C1.17826 7.15816 0.83693 8.56862 0.835938 9.99984C0.835938 11.4765 1.19927 12.8723 1.83344 14.1148L4.86927 11.8123Z",
					fill: "#FBBC05"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.1848 4.37815C11.9415 4.37815 13.1256 5.12148 13.8015 5.74315L16.4406 3.21732C14.8198 1.74065 12.7098 0.833984 10.1848 0.833984C6.52562 0.833984 3.36646 2.89148 1.82812 5.88565L4.85313 8.18815C5.23453 7.07703 5.95327 6.11269 6.90907 5.42968C7.86487 4.74667 9.01004 4.37906 10.1848 4.37815Z",
					fill: "#EB4335"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_17396_28159",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgGoogle);
export default ForwardRef;
